"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
    mergeMap,
    catchError,
    map,
    concatMap,
    switchMap,
    withLatestFrom,
} from "rxjs/operators";
import {
    getRealTimeRewardCodeComplete,
    getRealTimeRewardReasonListComplete,
    getParticipantListComplete,
    smsRealTimeRewardCodeComplete,
    homeCampaignListComplete,
    homeGetRealTimeRewardCampaignComplete,
    registerDealerParticipantComplete,
    homeRegisterLcvTeamMemberComplete,
    removeLcvTeamMemberComplete,
    updateLcvTeamMemberStatusComplete,
    getParticipantJobRoleComplete,
    homeGetLcvAssignableJobRolesComplete,
    getDealerParticipantListComplete,
    getDealerParticipantListRequest,
    ajaxError,
    homeChatbotReplyQuestionComplete,
    homeGetChatbotFaqQuestionsComplete,
    removeDealerParticipantComplete,
    updateDealerParticipantStatusComplete,
    requestActivateAccountComplete,
    homeUserLoginStatusComplete,
    homeGetTeamGamePlayDetailsComplete,
    homeGetDealerLiquidGoldScratchCodesComplete,
    homeGetLcvTeamGameCodesComplete,
    homeAssignParticipantLiquidGoldScratchCodeComplete,
    homeLcvGameCodeAllocationComplete,
    homeLcvGameCodeAllocationError,
    homeLcvGameCodeResetComplete,
    homeRemoveParticipantLiquidGoldScratchCodeComplete,
    homeResetGamePlayCodeComplete,
    homeSendGamePlayCodeComplete,
    homeGetTeamGamePlayDetailsRequest,
    homeGetDealerLiquidGoldScratchCodesRequest,
    homeGetLcvTeamGameCodesRequest,
    homeGetNotificationComplete,
    homeDeleteNotificationComplete,
    homeGetNotificationRequest,
    homeGetNotificationCountComplete,
    homeGetPopupStatusComplete,
    homeTurnOffPopupComplete,
} from "../_actions";
import { homeConstants, requestTypes, isLcvManagersJobRole } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const homeSmsRealTimeRewardCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_SMS_REALTIME_REWARD_CODE_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/sms-real-time-reward-code",
                    {
                        userId: payload.userId,
                        reasonId: payload.reasonId,
                        campaignId: payload.campaignId,
                        rewardCode: payload.rewardCode,
                    },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        payload.form.restart();
                        return smsRealTimeRewardCodeComplete(ajaxResponse);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetRealTimeRewardCampaignEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_REAL_TIME_REWARD_CAMPAIGN_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-real-time-reward-campaign",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetRealTimeRewardCampaignComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetRealTimeRewardCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_REALTIME_REWARD_CODE_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/get-real-time-reward-code",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getRealTimeRewardCodeComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetRealTimeRewardReasonListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_REALTIME_REWARD_REASON_LIST_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/get-real-time-reward-reason-list",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getRealTimeRewardReasonListComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetParticipantListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_PARTICIPANT_LIST_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/get-participant-list",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getParticipantListComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeCampaignListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_CAMPAIGN_LIST_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/campaign-list",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeCampaignListComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetChatBotReplyQuestionEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_CHATBOT_REPLY_QUESTION_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-chatbot-reply-question",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeChatbotReplyQuestionComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getParticipantJobRoleEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.GET_PARTICIPANT_JOB_ROLES_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/participant-job-roles",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getParticipantJobRoleComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getLcvAssignableJobRolesEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_LCV_ASSIGNABLE_JOB_ROLES_REQUEST),
        mergeMap((action) => {
            const dealershipId = action.payload?.dealershipId;
            return ajax
                .get(
                    `/api/home/lcv-assignable-job-roles?dealershipId=${dealershipId}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetLcvAssignableJobRolesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetChatbotFaqQuestionsEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_CHATBOT_FAQ_QUESTIONS_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-chatbot-faq-questions",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetChatbotFaqQuestionsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getDealerParticipantListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.GET_DEALER_PARTICIPANT_LIST_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-dealer-participants",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getDealerParticipantListComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const registerDealerParticipantEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.REGISTER_DEALER_PARTICIPANT_REQUEST),
        mergeMap((action) => {
            const { formRestart, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/home/register-dealer-participants",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        formRestart();
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            registerDealerParticipantComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),

                    catchError((error) =>
                        of(ajaxError(error)).pipe(
                            concatMap((failureAction) =>
                                of(
                                    failureAction,
                                    getDealerParticipantListRequest(),
                                ),
                            ),
                        ),
                    ),
                );
        }),
    );
};

export const registerLcvTeamMemberEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_REGISTER_LCV_TEAM_MEMBER_REQUEST),
        mergeMap((action) => {
            const { formRestart, dealershipId, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/lcv-team-member",
                    { ...payload, dealershipId },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        formRestart();
                        return of(
                            homeGetLcvTeamGameCodesRequest({ dealershipId }),
                            homeRegisterLcvTeamMemberComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const removeLcvTeamMemberEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_REMOVE_LCV_TEAM_MEMBER_REQUEST),
        mergeMap((action) => {
            const { dealershipId, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/remove-lcv-team-member",
                    { ...payload, dealershipId },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetLcvTeamGameCodesRequest({ dealershipId }),
                            removeLcvTeamMemberComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => {
                        if (error?.response) {
                            error.response.message =
                                error.response.errors?.[0] ??
                                error.response.message;
                        }
                        return of(ajaxError(error));
                    }),
                );
        }),
    );
};

export const updateLcvTeamMemberStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_UPDATE_LCV_TEAM_MEMBER_STATUS_REQUEST),
        mergeMap((action) => {
            const { dealershipId, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/update-lcv-team-member-status",
                    { ...payload, dealershipId },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetLcvTeamGameCodesRequest({ dealershipId }),
                            updateLcvTeamMemberStatusComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const removeDealerParticipantEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.REMOVE_DEALER_PARTICIPANT_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/remove-dealer-participant",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            removeDealerParticipantComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const updateDealerParticipantStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/update-dealer-participant-status",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            updateDealerParticipantStatusComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const requestActivateAccountEpic = (actions$, state$) => {
    return actions$.pipe(
        ofType(homeConstants.SEND_ACTIVATE_ACCOUNT_REQUEST),
        withLatestFrom(state$),
        mergeMap(([action, state]) => {
            const { dealershipId, ...payload } = action.payload;
            const isLcvManager = isLcvManagersJobRole(
                state.auth?.userProfileDetails?.jobRoleId,
            );

            return ajax
                .post(
                    "/api/home/request-activate-account",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        const refreshAction = isLcvManager
                            ? homeGetLcvTeamGameCodesRequest({ dealershipId })
                            : getDealerParticipantListRequest({
                                  dealerCode: payload.dealerCode,
                              });

                        return of(
                            refreshAction,
                            requestActivateAccountComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeUserLoginStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_USER_LOGIN_STATUS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/user-login-status",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(

                            homeUserLoginStatusComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getTeamGamePlayDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_TEAM_GAME_PLAY_DETAILS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/get-team-game-play-details",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(

                            homeGetTeamGamePlayDetailsComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getDealerLiquidGoldScratchCodesEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_DEALER_LIQUID_GOLD_SCRATCH_CODES_REQUEST),
        mergeMap((action) => {
            const dealerCode = action.payload?.dealerCode;
            if (!dealerCode) {
                return of(
                    homeGetDealerLiquidGoldScratchCodesComplete({
                        data: null,
                    }),
                );
            }

            return ajax
                .get(
                    `/api/home/dealer-liquid-gold-scratch-codes/${encodeURIComponent(
                        dealerCode,
                    )}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetDealerLiquidGoldScratchCodesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getLcvTeamGameCodesEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_LCV_TEAM_GAME_CODES_REQUEST),
        mergeMap((action) => {
            const { dealershipId } = action.payload;

            return ajax
                .get(
                    `/api/home/lcv-team-game-codes?dealershipId=${dealershipId}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetLcvTeamGameCodesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const assignParticipantLiquidGoldScratchCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            homeConstants.HOME_ASSIGN_PARTICIPANT_LIQUID_GOLD_SCRATCH_CODE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/home/assign-participant-liquid-gold-scratch-code",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeAssignParticipantLiquidGoldScratchCodeComplete(
                                ajaxResponse.response,
                            ),
                            homeGetDealerLiquidGoldScratchCodesRequest({
                                dealerCode: 18200,
                            }),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const lcvGameCodeAllocationEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_LCV_GAME_CODE_ALLOCATION_REQUEST),
        mergeMap((action) => {
            const { dealershipId, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/lcv-game-code-allocation",
                    { ...payload, dealershipId },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeLcvGameCodeAllocationComplete(
                                ajaxResponse.response,
                            ),
                            homeGetLcvTeamGameCodesRequest({ dealershipId }),
                        );
                    }),
                    catchError((error) => {
                        // A refused allocation (for example a team member who is not accredited)
                        // is shown in a popup on the dashboard with the API's own wording.
                        // Anything without an API message still goes to the common error handler.
                        const message =
                            error?.response?.errors?.[0] ??
                            error?.response?.message;
                        if (error?.status === 400 && message) {
                            return of(homeLcvGameCodeAllocationError(message));
                        }
                        if (error?.response) {
                            error.response.message = message;
                        }
                        return of(ajaxError(error));
                    }),
                );
        }),
    );
};

export const lcvGameCodeResetEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_LCV_GAME_CODE_RESET_REQUEST),
        mergeMap((action) => {
            const { dealershipId, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/lcv-game-code-reset",
                    { ...payload, dealershipId },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeLcvGameCodeResetComplete(
                                ajaxResponse.response,
                            ),
                            homeGetLcvTeamGameCodesRequest({ dealershipId }),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const removeParticipantLiquidGoldScratchCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            homeConstants.HOME_REMOVE_PARTICIPANT_LIQUID_GOLD_SCRATCH_CODE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/home/remove-participant-liquid-gold-scratch-code",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeRemoveParticipantLiquidGoldScratchCodeComplete(
                                ajaxResponse.response,
                            ),
                            homeGetDealerLiquidGoldScratchCodesRequest({
                                dealerCode: 18200,
                            }),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeSendGamePlayCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_TEAM_SEND_GAME_PLAY_CODE_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/team-send-play-code",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetTeamGamePlayDetailsRequest({}),
                            homeSendGamePlayCodeComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeResetGamePlayCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_TEAM_RESET_GAME_PLAY_CODE_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/team-reset-play-code",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetTeamGamePlayDetailsRequest({}),
                            homeResetGamePlayCodeComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetNotificationEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            homeConstants.HOME_GET_NOTIFICATIONS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/home/get-notification",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetNotificationComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeDeleteNotificationEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_DELETE_NOTIFICATIONS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/delete-notification",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetNotificationRequest({}),
                            homeDeleteNotificationComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetNotificationCountEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_NOTIFICATION_COUNT_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/get-notification-count",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetNotificationCountComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetPopupStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_POPUP_STATUS_REQUEST),
        mergeMap(() =>
            ajax
                .get(
                    "/api/home/get-popup-status",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetPopupStatusComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const homeTurnOffPopupEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_TURN_OFF_POPUP_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload || {};

            return ajax
                .post(
                    "/api/home/turn-off-popup",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeTurnOffPopupComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};







